// Outside users (clients, collaborators, subcontractors, suppliers) never use
// the staff app (#3963, parent #3957). The server refuses them every staff
// route (#3961); this is the matching client-side rule so they never even
// mount the staff shell — RequireAuth and the app shell send them to /portal.
//
// An admin's "View client portal" preview (#3954) gets exactly the client's
// routing — it must show what the client sees. Audited impersonation is a
// staff support session and keeps the staff app — same rule as
// middleware.OutsideRoleStaffOnly on the server.

const OUTSIDE_ROLES = new Set(['client', 'collaborator', 'subcontractor', 'supplier'])

export function isOutsideRole(role: unknown): boolean {
  return typeof role === 'string' && OUTSIDE_ROLES.has(role.trim().toLowerCase())
}

/** Whether a JWT belongs to an outside user (or a client preview) that must land in the client portal. */
export function isOutsideSessionToken(token: string | null): boolean {
  if (!token) return false
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    const claims = JSON.parse(atob(payload)) as { role?: string; preview?: boolean; preview_contact_id?: number; impersonated_by_uid?: number }
    if ((claims.impersonated_by_uid ?? 0) > 0) return false
    // Legacy un-scoped preview tokens (no client chosen) predate #3954 and
    // expire within an hour; they keep the old staff-app behaviour.
    if (claims.preview && !claims.preview_contact_id) return false
    return isOutsideRole(claims.role)
  } catch {
    return false
  }
}

export const CLIENT_PORTAL_HOME = '/portal'
